/* ============================================
   SPECASE — JavaScript
   Scroll Animations, Filtering, Interactions
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  const cartCountEl = document.querySelector('.cart-count');
  let cartCount = cartCountEl ? parseInt(cartCountEl.textContent, 10) || 0 : 0;

  // ── Scroll Reveal (IntersectionObserver) ──
  const revealElements = document.querySelectorAll('.reveal');
  
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  });

  revealElements.forEach(el => revealObserver.observe(el));

  // ── Header Scroll Effect ──
  const header = document.getElementById('header');
  let lastScrollY = 0;

  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    
    if (scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
    
    lastScrollY = scrollY;
  }, { passive: true });

  // ── Mobile Menu Toggle ──
  const menuToggle = document.getElementById('menuToggle');
  const navLinks = document.getElementById('navLinks');

  if (menuToggle && navLinks) {
    menuToggle.addEventListener('click', () => {
      menuToggle.classList.toggle('active');
      navLinks.classList.toggle('open');
      document.body.style.overflow = navLinks.classList.contains('open') ? 'hidden' : '';
    });

    // Close menu when clicking a link
    navLinks.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        menuToggle.classList.remove('active');
        navLinks.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ── Search Overlay & Live Search ──
  const searchBtn = document.getElementById('triggerSearch');
  const searchOverlay = document.getElementById('searchOverlay');
  const searchInput = document.getElementById('predictiveSearchInput');
  const searchResultsDiv = document.getElementById('predictiveSearchResults');
  let searchTimer;

  if (searchBtn && searchOverlay) {
    searchBtn.addEventListener('click', (e) => {
      e.preventDefault();
      searchOverlay.style.display = 'flex';
      setTimeout(() => {
        if (searchInput) searchInput.focus();
      }, 100);
    });
  }

  if (searchInput && searchResultsDiv) {
    const rootUrl = window.Shopify ? window.Shopify.routes.root : '/';
    
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimer);
      const query = this.value.trim();
      
      if (query.length < 2) {
        searchResultsDiv.style.display = 'none';
        searchResultsDiv.innerHTML = '';
        return;
      }
      
      searchTimer = setTimeout(() => {
        fetch(`${rootUrl}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
          .then(response => response.json())
          .then(data => {
            const products = data.resources.results.products;
            if (products && products.length > 0) {
              let html = '<h4 style="font-size:0.8rem; color:#999; margin: 0 0 12px; text-transform:uppercase; letter-spacing:0.05em; border-bottom:1px solid #eee; padding-bottom:8px;">Önerilen Ürünler</h4><div style="display:flex; flex-direction:column; gap:6px;">';
              products.forEach(p => {
                html += `
                  <a href="${p.url}" style="display:flex; align-items:center; gap:12px; padding:8px; border-radius:12px; transition:background 0.2s; text-decoration:none; color:#111;" onmouseover="this.style.background='#f5f5f7'" onmouseout="this.style.background='transparent'">
                    <img src="${p.image}" alt="${p.title}" style="width:48px; height:48px; border-radius:8px; object-fit:cover; background:#eee;">
                    <div>
                      <div style="font-weight:600; font-size:0.95rem; margin-bottom:2px;">${p.title}</div>
                      <div style="color:#666; font-size:0.85rem; font-weight:700;">${p.price}</div>
                    </div>
                  </a>
                `;
              });
              html += '</div>';
              html += `<a href="${rootUrl}search?q=${encodeURIComponent(query)}" style="display:block; text-align:center; padding:12px; border-radius:100px; margin-top:16px; font-weight:700; background:#f4f4f5; color:#111; font-size:0.85rem; text-decoration:none; text-transform:uppercase;">Tüm Sonuçları Görüntüle ↗</a>`;
              
              searchResultsDiv.innerHTML = html;
              searchResultsDiv.style.display = 'block';
            } else {
              searchResultsDiv.innerHTML = `<p style="padding:24px 16px; color:#666; text-align:center; font-style:italic;">"${query}" için sonuç bulunamadı.</p>`;
              searchResultsDiv.style.display = 'block';
            }
          })
          .catch(err => console.error("Search AJAX error:", err));
      }, 300); // 300ms debounce
    });
  }

  // ── Side Cart Drawer ──
  const cartToggles = document.querySelectorAll('.cart-toggle');
  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');
  const closeCartBtn = document.getElementById('closeCart');

  function openCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.add('open');
      cartOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.remove('open');
      cartOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  cartToggles.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    });
  });

  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ── Filter Buttons ──
  const filterBtns = document.querySelectorAll('.filter-btn');
  const productCards = document.querySelectorAll('.product-card');

  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      // Update active button
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const filter = btn.dataset.filter;

      productCards.forEach((card, index) => {
        const categories = card.dataset.category || '';
        
        if (filter === 'all' || categories.includes(filter)) {
          card.style.display = '';
          card.style.opacity = '0';
          card.style.transform = 'translateY(20px)';
          
          setTimeout(() => {
            card.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
          }, index * 60);
        } else {
          card.style.opacity = '0';
          card.style.transform = 'translateY(20px)';
          setTimeout(() => {
            card.style.display = 'none';
          }, 300);
        }
      });
    });
  });

  // ── Model Selectors ──
  document.querySelectorAll('.model-selector').forEach(select => {
    select.addEventListener('change', (e) => {
      e.stopPropagation();
      const card = select.closest('.product-card');
      const addBtn = card.querySelector('.quick-add-btn');
      addBtn.disabled = false;
      addBtn.textContent = 'Sepete Ekle';
    });

    // Prevent card click when interacting with select
    select.addEventListener('click', (e) => e.stopPropagation());
  });

  // ── Quick Add Buttons (AJAX) ──
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.classList.contains('product-card-overlay') && !form.closest('.product-card')) return;
    if (!form.matches('form[action*="/cart/add"]')) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    const btn = form.querySelector('.quick-add-btn');
    const idInput = form.querySelector('[name="id"]');
    
    if (!idInput || !idInput.value) {
      const sel = form.querySelector('select');
      if (sel) sel.focus();
      return;
    }
    
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Ekleniyor...';
    }
    
    const formData = {
      items: [{
        id: parseInt(idInput.value),
        quantity: parseInt(form.querySelector('[name="quantity"]')?.value || 1)
      }]
    };
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(res => res.json())
    .then(data => {
      // Success animation
      if (btn) {
        btn.textContent = '✓ Eklendi';
        btn.style.background = '#16a34a';
        btn.style.color = '#fff';
      }
      
      // Update cart counts
      fetch('/cart.js').then(r => r.json()).then(cart => {
        document.querySelectorAll('.cart-count, .drawer-cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.transform = 'scale(1.4)';
          setTimeout(() => el.style.transform = 'scale(1)', 200);
        });
        
        // Refresh cart drawer HTML
        fetch(window.location.pathname)
          .then(r => r.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('#cartDrawer');
            const oldDrawer = document.getElementById('cartDrawer');
            if (newDrawer && oldDrawer) {
              oldDrawer.innerHTML = newDrawer.innerHTML;
            }
            // Open cart drawer
            openCart();
          });
      });
      
      setTimeout(() => {
        if (btn) {
          btn.textContent = 'Sepete Ekle';
          btn.style.background = '';
          btn.style.color = '';
          btn.disabled = true;
        }
        // Reset selectors
        const selects = form.querySelectorAll('select:not([style*="display:none"])');
        selects.forEach(sel => sel.selectedIndex = 0);
      }, 2500);
    })
    .catch(err => {
      console.error('Cart add error:', err);
      if (btn) {
        btn.textContent = 'Hata!';
        btn.style.background = '#e53e3e';
        setTimeout(() => {
          btn.textContent = 'Sepete Ekle';
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
      }
    });
  });

  // ── Back to Top ──
  const backToTop = document.getElementById('backToTop');
  if (backToTop) {
    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ── Smooth Scroll for Anchor Links ──
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const targetId = anchor.getAttribute('href');
      if (targetId === '#') return;
      
      e.preventDefault();
      const targetEl = document.querySelector(targetId);
      if (targetEl) {
        const offset = 80; // Header height
        const top = targetEl.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  // ── Cart Count Transition ──
  if (cartCountEl) {
    cartCountEl.style.transition = 'transform 0.2s ease';
  }

  // ── FAQ Accordion ──
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    
    question.addEventListener('click', () => {
      const isOpen = item.classList.contains('active');
      
      // Close all other items
      faqItems.forEach(otherItem => {
        otherItem.classList.remove('active');
        const otherAnswer = otherItem.querySelector('.faq-answer');
        if (otherAnswer) otherAnswer.style.maxHeight = null;
        const otherIcon = otherItem.querySelector('.faq-icon');
        if (otherIcon) otherIcon.textContent = '+';
      });

      if (!isOpen) {
        item.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + "px";
        const icon = item.querySelector('.faq-icon');
        if (icon) icon.textContent = '-';
      }
    });

    // Set initial max-height for pre-opened items
    if (item.classList.contains('active') && answer) {
      answer.style.maxHeight = answer.scrollHeight + "px";
      const icon = item.querySelector('.faq-icon');
      if (icon) icon.textContent = '-';
    }
  });

  // ── Product Detail Gallery ──
  const mainImage = document.querySelector('.product-gallery .main-image');
  const thumbs = document.querySelectorAll('.product-gallery .thumb');
  
  if (mainImage && thumbs.length > 0) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        // Remove active class from all
        thumbs.forEach(t => t.classList.remove('active'));
        // Add active to clicked
        thumb.classList.add('active');
        
        // Simple animation effect on main image
        const caseIcon = mainImage.querySelector('.case-icon-large');
        if(caseIcon) {
          caseIcon.style.opacity = '0';
          caseIcon.style.transform = 'scale(0.95)';
          
          // Get transform from thumb icon to apply to main icon (simulate different views)
          const thumbIcon = thumb.querySelector('.case-icon-small');
          const transform = thumbIcon ? thumbIcon.style.transform : 'none';
          
          setTimeout(() => {
            caseIcon.style.transform = transform;
            caseIcon.style.opacity = '1';
          }, 150);
        }
      });
    });
  }

  // ── Product Detail Quantity & Add to Cart ──
  const detailModelSelect = document.getElementById('productDetailModel');
  const detailAddBtn = document.getElementById('detailAddBtn');
  const qtyMinus = document.querySelector('.qty-btn.minus');
  const qtyPlus = document.querySelector('.qty-btn.plus');
  const qtyInput = document.querySelector('.qty-input');

  if (detailModelSelect && detailAddBtn) {
    detailModelSelect.addEventListener('change', () => {
      detailAddBtn.disabled = false;
      const priceDisplay = document.getElementById('productPrice');
      const selectedOption = detailModelSelect.options[detailModelSelect.selectedIndex];
      if (priceDisplay && selectedOption && selectedOption.dataset.price) {
        const comparePrice = selectedOption.dataset.comparePrice;
        priceDisplay.innerHTML = selectedOption.dataset.price + (comparePrice ? ` <span class="old-price">${comparePrice}</span>` : '');
      }
    });

    // Quantity controls
    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        let val = parseInt(qtyInput.value);
        if (val > 1) qtyInput.value = val - 1;
      });
      
      qtyPlus.addEventListener('click', () => {
        let val = parseInt(qtyInput.value);
        if (val < 10) qtyInput.value = val + 1;
      });
    }

    // Add to cart action
    detailAddBtn.addEventListener('click', () => {
      const selectedModel = detailModelSelect.options[detailModelSelect.selectedIndex].text;
      const qty = parseInt(qtyInput ? qtyInput.value : 1);
      
      cartCount += qty;
      if(cartCountEl) cartCountEl.textContent = cartCount;
      
      const originalText = detailAddBtn.textContent;
      detailAddBtn.textContent = '✓ Sepete Eklendi';
      detailAddBtn.style.background = '#4a6cf7';
      detailAddBtn.style.color = '#fff';
      
      if(cartCountEl) {
        cartCountEl.style.transform = 'scale(1.4)';
        setTimeout(() => {
          cartCountEl.style.transform = 'scale(1)';
        }, 200);
      }
      
      setTimeout(() => {
        detailAddBtn.textContent = originalText;
        detailAddBtn.style.background = '';
        detailAddBtn.style.color = '';
      }, 2000);
    });
  }


  // ── Premium UX Logic (Dark Mode, Cursor, Sticky Bar) ──
  // 3. Sticky Add to Cart (Product Page)
  const stickyBar = document.getElementById('stickyCartBar');
  const mainAddBtn = document.getElementById('detailAddBtn');
  
  if (stickyBar && mainAddBtn) {
    window.addEventListener('scroll', () => {
      const btnRect = mainAddBtn.getBoundingClientRect();
      // If original button scrolls out of view upwards
      if (btnRect.bottom < 0) {
        stickyBar.classList.add('visible'); stickyBar.style.bottom = '';
      } else {
        stickyBar.classList.remove('visible'); stickyBar.style.bottom = '';
      }
    }, {passive: true});
  }


  // ── Global Custom Select Polyfill ──
  // Automagically converts any ugly native <select> into a sleek custom dropdown!
  window.initCustomSelect = function(select) {
    if (!select) return;
    
    // Hide the native select
    select.style.display = 'none';

    // Prevent double execution by rebuilding if it exists
    if(select.parentElement && select.parentElement.classList.contains('c-select-wrapper')) {
      const oldWrapper = select.parentElement;
      oldWrapper.parentNode.insertBefore(select, oldWrapper);
      oldWrapper.remove();
    }

    // Create wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'c-select-wrapper';
    
    // Create trigger
    const trigger = document.createElement('div');
    trigger.className = 'c-select-trigger';
    const isLarge = select.classList.contains('model-select-large');
    if(!isLarge) trigger.classList.add('card-select-trigger');
    
    const textSpan = document.createElement('span');
    textSpan.className = 'c-select-text';
    textSpan.textContent = select.options[select.selectedIndex]?.text || 'Model Seçin';
    
    // Trigger SVG Arrow
    const svgIcon = document.createElement('div');
    svgIcon.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-left:8px; flex-shrink:0;"><path d="m6 9 6 6 6-6"/></svg>`;
    
    trigger.appendChild(textSpan);
    trigger.appendChild(svgIcon.firstChild);
    
    // Create options container
    const optionsContainer = document.createElement('div');
    optionsContainer.className = 'c-select-options';
    if(!isLarge) optionsContainer.classList.add('card-select-options');
    
    // Parse optgroups and options
    Array.from(select.children).forEach(child => {
      if (child.tagName === 'OPTGROUP') {
        const groupLabel = document.createElement('div');
        groupLabel.className = 'c-optgroup';
        groupLabel.textContent = child.label;
        optionsContainer.appendChild(groupLabel);
        
        Array.from(child.children).forEach(opt => {
          const optionDiv = document.createElement('div');
          optionDiv.className = 'c-option';
          optionDiv.setAttribute('data-value', opt.value);
          optionDiv.textContent = opt.textContent;
          optionsContainer.appendChild(optionDiv);
        });
      } else if (child.tagName === 'OPTION' && child.value !== "") {
        const optionDiv = document.createElement('div');
        optionDiv.className = 'c-option';
        optionDiv.setAttribute('data-value', child.value);
        optionDiv.textContent = child.textContent;
        optionsContainer.appendChild(optionDiv);
      }
    });
    
    wrapper.appendChild(trigger);
    wrapper.appendChild(optionsContainer);
    
    // Insert wrapper before native select, then move select inside wrapper
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);
    
    // Logic: Toggle Dropdown
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      
      // Close all other open dropdowns
      document.querySelectorAll('.c-select-options.open').forEach(openMenu => {
        if(openMenu !== optionsContainer) openMenu.classList.remove('open');
      });
      optionsContainer.classList.toggle('open');
    });
    
    // Logic: Select Option
    optionsContainer.querySelectorAll('.c-option').forEach(optDiv => {
      optDiv.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        
        const val = optDiv.getAttribute('data-value');
        const text = optDiv.textContent;
        textSpan.textContent = text;
        optionsContainer.classList.remove('open');
        
        select.value = val;
        // Fire native change so existing scripts (Quick Add, etc) work
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  };

  // Initialize on page load
  document.querySelectorAll('.model-selector, .model-select-large, .card-brand-selector, .card-model-selector').forEach(select => {
    window.initCustomSelect(select);
  });

  // Desktop drag support for horizontal product sliders.
  document.querySelectorAll('.product-slider').forEach(slider => {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    slider.style.cursor = 'grab';

    slider.addEventListener('mousedown', e => {
      if (e.target.closest('a, button, select, input, .c-select-wrapper')) return;
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      slider.style.cursor = 'grabbing';
      slider.style.scrollSnapType = 'none';
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.style.cursor = 'grab';
      slider.style.scrollSnapType = 'x mandatory';
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.style.cursor = 'grab';
      slider.style.scrollSnapType = 'x mandatory';
    });

    slider.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      slider.scrollLeft = scrollLeft - ((x - startX) * 1.6);
    });
  });
  
  // Close on outside click
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.c-select-options.open').forEach(menu => {
      if (!menu.parentElement.contains(e.target)) {
        menu.classList.remove('open');
      }
    });
  });

});
